import type { ApiClient } from "@carepass/api-client";
import type { Schemas } from "../workspace/api.generated";
import type { ExternalLogCriteria } from "./schema";

export async function getAuditLogs(api: ApiClient, signal?: AbortSignal) {
  return (await api.get<Schemas["AuditLogView"][]>("/api/v1/admin/operations/audit-logs", {
    signal,
    cache: "no-store",
  })).data;
}

export async function getExternalApiLogs(api: ApiClient, criteria: ExternalLogCriteria, signal?: AbortSignal) {
  return (await api.get<Schemas["ExternalApiLogView"][]>("/api/v1/admin/operations/external-api-logs", {
    query: {
      providerCode: criteria.providerCode || undefined,
      requestId: criteria.requestId || undefined,
      businessRefType: criteria.businessRefType || undefined,
      businessRefId: criteria.businessRefId || undefined,
      limit: criteria.limit,
    },
    signal,
    cache: "no-store",
  })).data;
}
